import React from "react";
import "./Header.css";
import { Link } from "react-scroll"; // Correct import for Link
import Logo from "../../assets/logo.png"; // Ensure path is correct

// Assuming setMenuOpened is passed as a prop from a parent component
// (e.g., from App.js or a Layout component that manages mobile menu state)
const Header = ({ setMenuOpened }) => {
  // If you want to manage the menu state *within* this Header component,
  // you would need to import useState and define it like this:
  // import { useState } from "react";
  // const [menuOpened, setMenuOpened] = useState(false);
  // And then you'd also need a hamburger icon and conditional rendering for the menu.
  // For now, we'll stick to the assumption it's a prop.

  return (
    <div className="header">
      <img src={Logo} alt="Fitness Logo" className="logo" /> {/* Added alt text for accessibility */}
      <ul className="header-menu">
        {/* Each list item should ideally be a Link from react-scroll */}
        <li onClick={() => setMenuOpened(false)}>
          <Link
            to="hero" // Assuming 'hero' is the ID of your home/hero section
            span={true}
            smooth={true}
          >
            Home
          </Link>
        </li>
        <li onClick={() => setMenuOpened(false)}>
          <Link
            to="programs" // Assuming 'programs' is the ID of your programs section
            span={true}
            smooth={true}
          >
            Programs
          </Link>
        </li>
        <li onClick={() => setMenuOpened(false)}>
          <Link
            to="reasons" // Assuming 'why-us' is the ID of your why us section
            span={true}
            smooth={true}
          >
            Why us
          </Link>
        </li>
        <li onClick={() => setMenuOpened(false)}>
          <Link
            to="join-us" // Assuming 'plans' is the ID of your plans section
            span={true}
            smooth={true}
          >
            Plans
          </Link>
        </li>
        <li onClick={() => setMenuOpened(false)}>
          <Link
            to="testimonials" // Assuming 'testimonials' is the ID of your testimonials section
            span={true}
            smooth={true}
          >
            Testimonials
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default Header;